import { BreachListData, BreachListFilters } from "../models/breach-list-model";

export class CacheService {
  private breachListFilters: BreachListFilters = new BreachListFilters();
  private breachListData: BreachListData;

  getBreachListFilters(): BreachListFilters {
    return this.breachListFilters;
  }

  setBreachListFilters(breachListFilters: BreachListFilters): void {
    this.breachListFilters = breachListFilters;
  }

  getBreachListData(): BreachListData {
    return this.breachListData;
  }

  setBreachListData(breachListData: BreachListData): void {
    this.breachListData = breachListData;
  }

  public isVenueIdChanged(venueId) {
    if ( (this.breachListData && this.breachListData.filters && this.breachListData.filters.venueId !== venueId)
          || (this.breachListFilters && this.breachListFilters.venueId !== venueId ) ) {
      return true;
    } else {
      return false;
    }
  }

  public clearCache() {
    this.breachListFilters = new BreachListFilters();
    this.breachListData = null;

  }


}



// WEBPACK FOOTER //
// ./client/app/services/cache.service.ts